import React from 'react';
import { Box, Typography, Chip, Alert } from '@mui/material';
import { useShallow } from 'zustand/react/shallow';
import BaySection from './Components/BaySection';
import { useBayStore } from '../Stores/BayStore';

interface BayInspectionsListProps {
    isMobile: boolean;
}

const BayInspectionsList: React.FC<BayInspectionsListProps> = ({
    isMobile,
}) => {
    const bays = useBayStore(useShallow((state) => state.bays));
    return (
        <Box>
            <Typography variant="h6" sx={{ mb: isMobile ? 2 : 3, fontWeight: 600, color: 'text.primary' }}>
                Bay Inspections
                {bays.length > 0 && (
                    <Chip
                        label={`${bays.length} Bays`}
                        size="small"
                        sx={{ ml: isMobile ? 1 : 2 }}
                        color="primary"
                    />
                )}
            </Typography>

            {bays.length === 0 ? (
                <Alert severity="info">
                    Please select a storage location to load bay information.
                </Alert>
            ) : (
                bays.map((bay, index) => (
                    <BaySection
                        key={bay.bayId ?? bay.bay ?? index}
                        bayIndex={index}
                        isMobile={isMobile}
                    />
                ))
            )}
        </Box>
    );
};

export default BayInspectionsList;
